import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const PrivacyPolicy = () => {
  return (
    <LegalPageLayout title="Privacy Policy">
      <div className="space-y-8 font-tamil-body leading-relaxed">
        <section>
          <h2 className="text-2xl font-bold text-amber-400 mb-4">Privacy Policy for Arulvaaku Nilayam</h2>
          <p>At Arulvaaku Nilayam, we prioritize your privacy.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-amber-300 mb-3">Data Collection</h3>
          <p>We collect your name and phone number only when you contact us via WhatsApp for a consultation.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-amber-300 mb-3">Data Usage</h3>
          <p>Your details are used strictly for providing astrology consultations and will not be shared with third parties.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-amber-300 mb-3">Advertising</h3>
          <p>We use Facebook Pixel and Google Tags to understand our website traffic and improve our services.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-amber-300 mb-3">Security</h3>
          <p>We take all necessary steps to ensure your personal information is kept confidential and secure.</p>
        </section>
      </div>
    </LegalPageLayout>
  );
};

export default PrivacyPolicy;
